























































































































































import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { isEmpty } from 'lodash';
import {
  Form,
  Layout,
  CardList,
  Footer,
  ModuleLayout,
  Message,
} from './components';
import { AppHeading, AppText } from '@/uikit';
import { Select, FormInput, Textarea } from '@/pages/profile/blocks/form';
import { Button } from '@/pages/profile/components';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import {
  INFO_TEXT,
  DESC_TEXT,
  ERROR_TEXT,
  PARAM_BUTTON_TEXT,
  CLOSE_BUTTON_TEXT,
} from './consts';
import { ModuleFormData, FormData, RequiredFormData } from './types';
import { mapItems } from '@/tools/mapitems';
import { StateModuleMixin } from '@/services';
import {
  eventOrdersService,
  dictionaryService,
  modulesService,
} from '@/services';
import removeEmptyDataFromObject from '@/tools/removeEmptyDataFromObject';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { LoaderMixin, StatusEnum } from '../profile/mixins';
import { Route } from 'vue-router';

const getModuleFormInit = (): ModuleFormData => ({
  modules: [],
  competence_new: '',
});

const getForm = (): FormData => ({
  cost_max: '',
  user_comment: '',
  program_name: '',
  competence_id: '',
  profession_id: '',
  students_count: '',
});

const getRequiredFormInit = (): RequiredFormData => ({
  edu_cats: [],
  edu_forms: [],
  edu_durations: [],
  prof_sphere_id: '',
});

@Component({
  components: {
    Form,
    Footer,
    Select,
    Button,
    Layout,
    AppText,
    Message,
    CardList,
    Textarea,
    FormInput,
    AppHeading,
    ModuleLayout,
    BreadcrumbsLayout,
  },
})
export default class NewProgram extends Mixins(StateModuleMixin, LoaderMixin) {
  @Inject() $api: AxiosInstance;

  breadcrumbs = [
    {
      text: 'Главная',
      to: { path: '/' },
    },
    {
      text: 'Заявка на новую программу',
    },
  ];

  success = false;
  isReadOnly: boolean = false;
  errors: any = {};
  descText = DESC_TEXT;
  costMaxError = false;
  errorsText = ERROR_TEXT;
  programForm = getForm();
  isOpenParamsForm = false;
  duration: Array<any> = [];
  studentsCountError = false;
  moduleForm = getModuleFormInit();
  requiredForm = getRequiredFormInit();

  get state() {
    return this.$store.state;
  }

  get profSpheres() {
    const { profSpheres } = this.state;
    return mapItems(profSpheres);
  }

  get professions() {
    const { unpublishedProfessions } = this.state;
    return mapItems(unpublishedProfessions);
  }

  get educationCategories() {
    const { educationCategories } = this.state;
    return mapItems(educationCategories);
  }

  get competences() {
    const { competences } = this.state;
    return mapItems(competences);
  }

  get educationForm() {
    const { educationForm } = this.state;
    return mapItems(educationForm);
  }

  get eduDurations() {
    const { duration } = this;
    return mapItems(duration);
  }
  get isModulesListNotEmpty(): boolean {
    return this.items && this.items.length > 0;
  }

  get paramButtonText(): string {
    return this.isOpenParamsForm ? CLOSE_BUTTON_TEXT : PARAM_BUTTON_TEXT;
  }

  get infoText(): string {
    return this.isOpenParamsForm ? PARAM_BUTTON_TEXT : INFO_TEXT;
  }

  get isDisabled() {
    const {
      errors,
      isRequired,
      costMaxError,
      isOpenParamsForm,
      studentsCountError,
    } = this;
    return !isOpenParamsForm
      ? false
      : isEmpty(errors) && isRequired && !studentsCountError && !costMaxError
      ? false
      : true;
  }

  get isRequired(): boolean {
    const { prof_sphere_id, edu_cats, edu_forms, edu_durations } =
      this.requiredForm;
    return (
      prof_sphere_id.length > 0 &&
      isArrayNotEmpty(edu_cats) &&
      isArrayNotEmpty(edu_forms) &&
      isArrayNotEmpty(edu_durations)
    );
  }

  @Watch('isModulesListNotEmpty', { immediate: true })
  setModuleForm(value: boolean) {
    if (!value) {
      this.isOpenParamsForm = true;
    } else {
      this.isOpenParamsForm = false;
      this.moduleForm.modules = this.items.map(({ id }) => id);
    }
  }

  @Watch('requiredForm.prof_sphere_id')
  clearErrorProfSphereId(value: Array<any>) {
    if (this.errors.prof_sphere_id && value.length)
      delete this.errors.prof_sphere_id;
  }

  @Watch('requiredForm.edu_forms')
  clearErrorEduForms(value: Array<any>) {
    if (this.errors.edu_forms && value.length) delete this.errors.edu_forms;
  }

  @Watch('requiredForm.edu_cats')
  clearErrorEduCats(value: Array<any>) {
    if (this.errors.edu_cats && value.length) delete this.errors.edu_cats;
  }

  @Watch('requiredForm.edu_durations')
  clearErrorEduDurations(value: Array<any>) {
    if (this.errors.edu_durations && value.length)
      delete this.errors.edu_durations;
  }

  @Watch('programForm.cost_max')
  isCostCorrect(value: string) {
    if (value) {
      this.costMaxError = !/^[1-9]\d*$/.test(value);
    } else {
      this.costMaxError = false;
    }
  }

  @Watch('programForm.students_count')
  isStudentsCountCorrect(value: string) {
    if (value) {
      this.studentsCountError = !/^[1-9]\d*$/.test(value);
    } else {
      this.studentsCountError = false;
    }
  }

  @Watch('$route', { immediate: true })
  onRouteChange(to: Route): void {
    const { id } = to.params;
    if (id) {
      this.isReadOnly = true;
      this.getEduDurations();
      this.getData(id);
    } else {
      this.getEduDurations();
    }
  }

  destroyed() {
    this.write({
      items: [],
      show: true,
    });
  }

  closeMessage() {
    this.success = false;
  }

  toggleParamForm() {
    this.isOpenParamsForm = !this.isOpenParamsForm;
  }

  cancellation() {
    this.$router.push({ path: '/' });
  }

  clearForms() {
    this.programForm = getForm();
    this.moduleForm = getModuleFormInit();
    this.requiredForm = getRequiredFormInit();
  }

  arrayStringToNumber(val: Array<any>) {
    const data = val;
    const result: any = [];
    for (const item of data) {
      const number = Number(item);
      result.push(number);
    }
    return result;
  }

  async getData(id: string) {
    try {
      this.status = StatusEnum.LOADING;
      const { data } = await eventOrdersService(this.$api).getEventOrder(id);
      this.moduleForm.competence_new = data.competence_new;
      if (data.modules.length) {
        await this.getModulesData(data.modules);
        await this.$nextTick();
        this.toggleParamForm();
      }
      this.programForm.program_name = data.program_name;
      this.requiredForm.prof_sphere_id = data.prof_sphere_id;
      this.programForm.competence_id = data.competence_id;
      this.programForm.profession_id = data.profession_id;
      this.requiredForm.edu_forms = this.arrayStringToNumber(data.edu_forms);
      this.requiredForm.edu_cats = this.arrayStringToNumber(data.edu_cats);
      this.requiredForm.edu_durations = this.arrayStringToNumber(
        data.edu_durations,
      );
      this.programForm.students_count = data.students_count;
      this.programForm.cost_max = data.cost_max;
      this.programForm.user_comment = data.cost_max;
    } catch (err) {
      this.status = StatusEnum.SUCCESS;
    }
  }

  async getModulesData(ids: Array<string>) {
    try {
      const params = {
        ids: ids,
      };
      const { data } = await modulesService(this.$api).getModules(params);
      this.write({
        items: [],
        show: false,
      });
      this.write({
        items: data,
        show: false,
      });
      return Promise.resolve();
    } catch (err) {
      this.write({
        items: [],
        show: false,
      });
      return Promise.resolve();
    }
  }

  async sendNewProgram() {
    const { moduleForm, programForm, requiredForm } = this;
    try {
      this.status = StatusEnum.LOADING;
      await eventOrdersService(this.$api).postEventOrderCreate(
        removeEmptyDataFromObject({
          ...moduleForm,
          ...programForm,
          ...requiredForm,
        }),
      );
      this.clear();
      this.clearForms();
      this.success = true;
      this.status = StatusEnum.SUCCESS;
    } catch (err) {
      if (err.response.data && err.response.data.err_code === 400) {
        const { errors } = err.response.data;
        if (isArrayNotEmpty(errors)) {
          this.errors = errors.reduce((res: any, { attribute, msg }: any) => {
            res[attribute] = msg;
            return res;
          }, {});
          this.isOpenParamsForm = true;
          this.status = StatusEnum.SUCCESS;
        }
      }
    }
  }

  async getEduDurations() {
    try {
      const { data } = await dictionaryService(this.$api).getEduDurations();
      this.duration = data;
      this.status = StatusEnum.SUCCESS;
    } catch (err) {
      this.duration = [];
      this.status = StatusEnum.SUCCESS;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newprogram/NewProgram.vue